import React from "react";
import { useBackofficeTopBarTitle } from "./useBackofficeTopBarTitle";

interface BackofficeTopBarContainerProps {
  title?: string;
  children: React.ReactNode;
}

export const BackofficeTopBarContainer: React.FC<
  BackofficeTopBarContainerProps
> = ({ title, children }) => {
  useBackofficeTopBarTitle(title);
  return <>{children}</>;
};
